import constants from './constants.js'

export const TOKEN_KEY = constants.TOKEN_KEY

export function getAuthToken(response) {
    const token = response?.token
        || response?.access_token
        || response?.accessToken
        || response?.jwt
        || response?.data?.token
        || response?.data?.access_token
        || response?.data?.accessToken
        || null

    return typeof token === 'string' && token.startsWith('Bearer ')
        ? token.slice(7).trim()
        : token
}

export function clearSession() {
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    localStorage.removeItem('token_age')
    localStorage.removeItem('favorites')
    localStorage.removeItem('subscriptions')
}

export function ensureTokenKey() {
    const storedTokenKey = localStorage.getItem('token_key')
    if (storedTokenKey !== TOKEN_KEY) {
        clearSession()
        localStorage.setItem('token_key', TOKEN_KEY)
        return true
    }
    return false
}

export function redirectToLogin() {
    clearSession()
    const path = window.location.pathname
    if (path !== '/login') {
        window.location.href = `/login${window.location.search || ''}`
    }
}
